const wrongWordsMap = new Map();
wrongWordsMap.set("danny", 4);
wrongWordsMap.set("is", 3);
wrongWordsMap.set("super", 3);
wrongWordsMap.set("swag", 2);
wrongWordsMap.set("and", 1);
wrongWordsMap.set("cool", 1);
export const UserData = [
    {
        id: "Peppa Pig",
        session: 1,
        accuracy: 40,
        cwpm: 20,
        correctWords: 6,
        wrongWords: 27,
        correctWordsPercentage: 24,
        incorrectWordsPercentage: 64,
        partialWordsPercentage: 12,
        passageScore: 92,
        userScore: 11,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "The Cat and the Hat",
        session: 2,
        accuracy: 89,
        cwpm: 52,
        correctWords: 32,
        wrongWords: 5,
        correctWordsPercentage: 93,
        incorrectWordsPercentage: 2,
        partialWordsPercentage: 5,
        passageScore: 75,
        userScore: 70,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "If You Give a Mouse a Cookie",
        session: 3,
        accuracy: 75,
        cwpm: 67,
        correctWords: 21,
        wrongWords: 14,
        correctWordsPercentage: 52,
        incorrectWordsPercentage: 40,
        partialWordsPercentage: 2,
        passageScore: 56,
        userScore: 23,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "Finding Nemo",
        session: 4,
        accuracy: 87,
        cwpm: 64,
        correctWords: 18,
        wrongWords: 4,
        correctWordsPercentage: 68,
        incorrectWordsPercentage: 22,
        partialWordsPercentage: 10,
        passageScore: 67,
        userScore: 56,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "The Cat and the Hat",
        session: 5,
        accuracy: 91,
        cwpm: 54,
        correctWords: 63,
        wrongWords: 11,
        correctWordsPercentage: 45,
        incorrectWordsPercentage: 45,
        partialWordsPercentage: 10,
        passageScore: 42,
        userScore: 31,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "Peppa Pig",
        session: 6,
        accuracy: 3,
        cwpm: 42,
        correctWords: 19,
        wrongWords: 3,
        correctWordsPercentage: 67,
        incorrectWordsPercentage: 13,
        partialWordsPercentage: 20,
        passageScore: 56,
        userScore: 58,
        wrongWordsMap: wrongWordsMap,
    }
]